var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1196_307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.3699 26.5487V15.8563H70.9052C75.8499 15.8563 79.8725 13.3959 79.8725 8.45141V0H77.1167C72.1721 0 68.1494 4.02281 68.1494 8.96734V12.1959C68.1494 7.25141 64.1266 3.22859 59.1821 3.22859H56.4263V10.1175C56.4263 12.5127 57.3591 14.7647 59.0527 16.4583C60.7464 18.152 62.9983 19.0848 65.3936 19.0847H65.6824V26.5487H56.4263V80H80V26.5487H70.3699Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2844 34.4661H42.8197C47.7643 34.4661 51.7871 32.0058 51.7871 27.0613V18.6099H49.0313C44.0868 18.6099 40.0639 22.6327 40.0639 27.5772V30.8058C40.0639 25.8613 36.0411 21.8385 31.0966 21.8385H28.3408V28.7274C28.3408 31.1225 29.2736 33.3746 30.9672 35.0681C32.661 36.7619 34.9129 37.6947 37.3082 37.6946H37.5969V45.1586H28.3408V79.9999H51.9146V45.1586H42.2844V34.4661Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9436 52.5027H14.4789C19.4234 52.5027 23.4463 50.0424 23.4463 45.0979V36.6465H20.6905C15.7459 36.6465 11.7231 40.6693 11.7231 45.6138V48.8424C11.7231 43.8979 7.70031 39.8751 2.75578 39.8751H0V46.764C0 49.1591 0.932813 51.4112 2.62641 53.1048C4.32016 54.7985 6.57203 55.7313 8.96734 55.7312H9.25609V63.1952H0V80.0001H23.5737V63.1951H13.9436V52.5027Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1196_307"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.83f6e8e23c29eafaad98f725fe7a9b17.svg";
export { ForwardRef as ReactComponent };